import { render, staticRenderFns } from "./CoTwoHmcForm.vue?vue&type=template&id=84b6618e&scoped=true&"
import script from "./CoTwoHmcForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoHmcForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b6618e",
  null
  
)

export default component.exports